import Script, {Props} from './Script'

export default Script
export {Props}
